import * as z from 'zod';

import { agreementInstallmentsQuerySchema, agreementPaymentQuerySchema } from './agreement-installments-query-schema';

export const agreementPaymentMutationSchema = agreementPaymentQuerySchema;

export type AgreementPaymentMutationSchema = z.infer<typeof agreementPaymentMutationSchema>;

export const agreementPaymentCreateSchema = agreementPaymentMutationSchema.omit({
  id: true,
});

export type AgreementPaymentCreateSchema = z.infer<typeof agreementPaymentCreateSchema>;

const agreementInstallmentsMutationSchema = agreementInstallmentsQuerySchema
  .omit({
    invoice_number: true,
    paid: true,
    remaining_balance: true,
    invoice_id: true,
    invoice: true,
  })
  .extend({
    /**
     * Optional PIN to override a revenue lockdown period.
     * (Scaffolding until backend supports it for installments.)
     */
    lockdown_override_pin: z.string().optional(),
    override_justification_note: z.string().optional(),
  });

export type AgreementInstallmentsMutationSchema = z.infer<typeof agreementInstallmentsMutationSchema>;

export const agreementInstallmentsCreateSchema = agreementInstallmentsMutationSchema.omit({
  id: true,
});

export type AgreementInstallmentsCreateSchema = z.infer<typeof agreementInstallmentsCreateSchema>;
